import React from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

// Extracted constants to avoid recreation on every render
const BUTTON_CLASSES = `
  inline-flex items-center justify-center gap-2
  h-10 px-4
  text-sm font-medium
  border border-gray-300 rounded-md
  bg-white text-primary-700
  transition-colors duration-150
  hover:bg-primary-50 hover:border-primary-300
  focus:outline-none focus:ring-2 focus:ring-blue-100
  disabled:pointer-events-none disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200
`.trim();

const ICON_CLASSES = 'w-5 h-5';

export interface PaginationControlsProps {
  disabled?: boolean;
  hasNext: boolean;
  hasPrev: boolean;
  testId?: string;
  onNext: () => void;
  onPrev: () => void;
}

export const PaginationControls: React.FC<PaginationControlsProps> = React.memo(({
  hasNext,
  hasPrev,
  onNext,
  onPrev,
  disabled = false,
  testId = 'pagination-controls',
}) => {
  return (
    <div className="flex items-center gap-2" data-testid={testId}>
      <button
        type="button"
        onClick={onPrev}
        disabled={!hasPrev || disabled}
        aria-label="Go to previous page"
        aria-disabled={!hasPrev || disabled}
        data-testid={`${testId}-prev`}
        className={BUTTON_CLASSES}
      >
        <FiChevronLeft className={ICON_CLASSES} />
        <span>Previous</span>
      </button>

      <button
        type="button"
        onClick={onNext}
        disabled={!hasNext || disabled}
        aria-label="Go to next page"
        aria-disabled={!hasNext || disabled}
        data-testid={`${testId}-next`}
        className={BUTTON_CLASSES}
      >
        <span>Next</span>
        <FiChevronRight className={ICON_CLASSES} />
      </button>
    </div>
  );
});

PaginationControls.displayName = 'PaginationControls';
